var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "minicart-item" },
      [
        _c(
          "div",
          {
            staticClass: "flex-between-center cursor-pointer",
            on: {
              click: function ($event) {
                _vm.isCollapsed = !_vm.isCollapsed
              },
            },
          },
          [
            _c("div", { staticClass: "flex-start-center" }, [
              _c("i", {
                staticClass: "fie-icon_takeaway2 fsize-26 mob-fsize-22 mr-10",
              }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "text-bold color-grey1 text-uppercase fsize-16 mob-fsize-14",
                  },
                  [_vm._v("Panier")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-bold color-grey2 fsize-10" }, [
                  _vm._v(
                    "\n\t\t\t\t\t\t" +
                      _vm._s(
                        _vm.orderTotalQtyItems(_vm.order.oi) > 1
                          ? _vm.orderTotalQtyItems(_vm.order.oi) + " articles"
                          : _vm.orderTotalQtyItems(_vm.order.oi) + " article"
                      ) +
                      "\n\t\t\t\t\t"
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("collapse-indicator", { attrs: { open: !_vm.isCollapsed } }),
          ],
          1
        ),
        _vm._v(" "),
        _c("collapse-transition", [
          !_vm.isCollapsed
            ? _c(
                "ul",
                { ref: "autoAnimate", staticClass: "my-20 fsize-12" },
                _vm._l(_vm.order.oi, function (item, i) {
                  return _c(
                    "li",
                    {
                      key: i,
                      staticClass:
                        "flex-between-center flex-wrap my-10 pb-10 border-bottom-grey7",
                    },
                    [
                      item.product.imt
                        ? _c("div", { staticClass: "prodThumb mr-10" }, [
                            _c("img", {
                              staticClass: "img-fit radius-4",
                              attrs: {
                                src: _vm.UrlService.imagePath(
                                  item.product.ShopId,
                                  item.product.imt
                                ),
                                alt: item.product.dn,
                              },
                              on: {
                                error: function ($event) {
                                  $event.target.src = "dist/assets/no-img.png"
                                },
                              },
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "titleProd" }, [
                        item.product.ty == _vm.PRODUCT_TYPES.Product
                          ? _c("div", [
                              _c("span", { staticClass: "qty" }, [
                                _vm._v(_vm._s(item.qty)),
                                _c("span", { staticClass: "multiple" }, [
                                  _vm._v("x"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "title" }, [
                                _vm._v(_vm._s(item.product.dn)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "optionProdList" },
                                [
                                  _c("list-summary", {
                                    attrs: {
                                      list: item.OptionGroups,
                                      "list-property": "Options",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item.product.ty == _vm.PRODUCT_TYPES.Menu
                          ? _c("div", [
                              _c("span", { staticClass: "qty" }, [
                                _vm._v(_vm._s(item.qty)),
                                _c("span", { staticClass: "multiple" }, [
                                  _vm._v("x"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "title" }, [
                                _vm._v(_vm._s(_vm.itemName(item))),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "price" }, [
                        _vm._v(
                          _vm._s(
                            _vm.order.shop &&
                              _vm.order.shop.info &&
                              _vm.order.shop.info.hidePrices &&
                              !_vm.manager
                              ? ""
                              : _vm.ShopService.prix(_vm.itemTotal(item))
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      item.product.ty == _vm.PRODUCT_TYPES.Menu
                        ? _c(
                            "div",
                            { staticClass: "subProd mt-10 w-100 ml-20" },
                            _vm._l(
                              _vm.displayedCategories(item),
                              function (category, i) {
                                return _c(
                                  "div",
                                  { key: i },
                                  _vm._l(
                                    category.MenuCategoryItems,
                                    function (subitem, j) {
                                      return _c("cart-subitem", {
                                        key: j,
                                        attrs: {
                                          "minicart-version": true,
                                          item: subitem,
                                          category: category,
                                          "hide-prices":
                                            _vm.order.shop &&
                                            _vm.order.shop.info &&
                                            _vm.order.shop.info.hidePrices &&
                                            !_vm.manager,
                                          "xbase-qty": "item.qty",
                                          "base-qty": 1,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                )
                              }
                            ),
                            0
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }